import { useCallback } from 'react';
import { clearMultiSelection } from '@components/MainStage/clearMultiSelection';
import { getFocusOnState } from '@components/MainStage/focusOn.store';
import { getListSearchState } from '@components/MainStage/listSearch.store';

/**
 * Clears the transient canvas state — multi-selection, Focus On and the list
 * search — in one call. Each clear is a self-guarded no-op, so calling this
 * with nothing active does nothing.
 *
 * Deliberately does not touch filter selections: AC6.3 requires Escape to
 * leave the user's filter choices intact, and the list-search header calls
 * this for the same three things.
 */
const useClearAll = () =>
  useCallback(() => {
    clearMultiSelection();
    getFocusOnState().clear();
    getListSearchState().reset();
  }, []);

export default useClearAll;
